import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateWidgetTaskInProgress = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 138,
	height: 138,
	viewBox: "0 0 138 138",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M136.106 79.8735L131.432 84.5474C131.109 84.8708 130.586 84.8708 130.264 84.5474C129.942 84.2241 129.941 83.701 130.264 83.3794L134.938 78.7054C135.261 78.382 135.784 78.382 136.106 78.7054C136.429 79.0288 136.429 79.5519 136.106 79.8735Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M136.106 84.546C135.783 84.8693 135.26 84.8693 134.938 84.546L130.264 79.872C129.941 79.5486 129.941 79.0256 130.264 78.704C130.588 78.3806 131.111 78.3806 131.432 78.704L136.106 83.3779C136.43 83.7013 136.43 84.2244 136.106 84.546Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.042 12.8061L95.3679 17.48C95.0445 17.8034 94.5215 17.8034 94.1999 17.48C93.8783 17.1567 93.8765 16.6336 94.1999 16.312L98.8738 11.638C99.1972 11.3147 99.7203 11.3147 100.042 11.638C100.365 11.9614 100.365 12.4845 100.042 12.8061Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100.042 17.4788C99.7187 17.8022 99.1956 17.8022 98.874 17.4788L94.2001 12.8049C93.8767 12.4815 93.8767 11.9584 94.2001 11.6368C94.5234 11.3134 95.0465 11.3134 95.3681 11.6368L100.042 16.3108C100.365 16.6342 100.365 17.1572 100.042 17.4788Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.59541 58.2496L3.19621 64.6488C2.75347 65.0915 2.03734 65.0915 1.59702 64.6488C1.1567 64.2061 1.15428 63.4899 1.59702 63.0496L7.99622 56.6504C8.43896 56.2077 9.15509 56.2077 9.59541 56.6504C10.0382 57.0932 10.0382 57.8093 9.59541 58.2496Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.59558 64.6471C9.15284 65.0898 8.43671 65.0898 7.99639 64.6471L1.59719 58.2479C1.15445 57.8052 1.15445 57.089 1.59719 56.6487C2.03994 56.206 2.75606 56.206 3.19639 56.6487L9.59558 63.0479C10.0383 63.4906 10.0383 64.2068 9.59558 64.6471Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M69.8363 128.416C99.2604 128.416 123.113 104.563 123.113 75.1392C123.113 45.7151 99.2604 21.8621 69.8363 21.8621C40.4121 21.8621 16.5591 45.7151 16.5591 75.1392C16.5591 104.563 40.4121 128.416 69.8363 128.416Z",
			fill: "#EBF3FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8557 22.4654C80.9999 22.1245 83.0195 23.5933 83.3604 25.7375L94.4487 95.7551C94.7896 97.8994 93.3208 99.919 91.1766 100.26L37.4306 108.771C35.2864 109.112 33.2668 107.643 32.9258 105.499L21.8343 35.4815C21.4934 33.3373 22.9622 31.3176 25.1064 30.9767L78.8524 22.4654",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8555 22.4653C80.9997 22.1243 83.0193 23.5931 83.3603 25.7373L94.4485 95.755C94.7895 97.8992 93.3207 99.9188 91.1765 100.26L37.4305 108.771C35.2863 109.112 33.2667 107.643 32.9257 105.499L21.8342 35.4813C21.4932 33.3371 22.962 31.3175 25.1062 30.9765L78.8523 22.4653M78.1965 18.3146L24.4505 26.8258C20.0113 27.5275 16.9819 31.6978 17.6835 36.137L28.775 106.155C29.4766 110.594 33.647 113.623 38.0862 112.922L91.8322 104.411C96.2714 103.709 99.3009 99.5385 98.5992 95.0993L87.511 25.0816C86.8094 20.6424 82.639 17.613 78.1998 18.3146H78.1965Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.9746 19.8686L59.1987 17.1405C64.7167 16.2666 69.9082 20.0385 70.7822 25.5564L70.9253 26.4599C71.0863 27.4767 70.3919 28.4365 69.3718 28.598L35.8367 33.9095C34.8199 34.0705 33.8601 33.376 33.6986 32.356L33.5555 31.4525C32.6815 25.9346 36.4534 20.743 41.9713 19.8691L41.9746 19.8686Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3012 10.4776C52.7402 9.93288 55.9736 12.2821 56.5183 15.7211L57.0666 19.1828L44.6059 21.1564L44.0576 17.6947C43.5129 14.2557 45.8622 11.0222 49.3012 10.4776Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.201 18.3606C51.4757 18.3606 52.5091 17.3273 52.5091 16.0525C52.5091 14.7778 51.4757 13.7444 50.201 13.7444C48.9262 13.7444 47.8928 14.7778 47.8928 16.0525C47.8928 17.3273 48.9262 18.3606 50.201 18.3606Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_6463_2782",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 33,
			y: 16,
			width: 38,
			height: 18,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M41.9545 19.8451L59.1787 17.1171C64.6966 16.2431 69.8882 20.015 70.7621 25.533L70.9052 26.4364C71.0663 27.4532 70.3718 28.413 69.3518 28.5746L35.8167 33.886C34.7999 34.0471 33.8401 33.3526 33.6785 32.3326L33.5354 31.4291C32.6615 25.9112 36.4334 20.7196 41.9513 19.8457L41.9545 19.8451Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_6463_2782)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M73.0589 25.1913L31.2468 31.8137L31.8695 35.7449L73.6815 29.1226L73.0589 25.1913Z",
				fill: "#6BA6FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8557 22.4654C80.9999 22.1245 83.0195 23.5933 83.3604 25.7375L94.4487 95.7551C94.7896 97.8994 93.3208 99.919 91.1766 100.26L37.4306 108.771C35.2864 109.112 33.2668 107.643 32.9258 105.499L21.8343 35.4815C21.4934 33.3373 22.9622 31.3176 25.1064 30.9767L78.8524 22.4654",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.8555 22.4653C80.9997 22.1243 83.0193 23.5931 83.3603 25.7373L94.4485 95.755C94.7895 97.8992 93.3207 99.9188 91.1765 100.26L37.4305 108.771C35.2863 109.112 33.2667 107.643 32.9257 105.499L21.8342 35.4813C21.4932 33.3371 22.962 31.3175 25.1062 30.9765L78.8523 22.4653M78.1965 18.3146L24.4505 26.8258C20.0113 27.5275 16.9819 31.6978 17.6835 36.137L28.775 106.155C29.4766 110.594 33.647 113.623 38.0862 112.922L91.8322 104.411C96.2714 103.709 99.3009 99.5385 98.5992 95.0993L87.511 25.0816C86.8094 20.6424 82.639 17.613 78.1998 18.3146H78.1965Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.9746 19.8686L59.1987 17.1405C64.7167 16.2666 69.9082 20.0385 70.7822 25.5564L70.9253 26.4599C71.0863 27.4767 70.3919 28.4365 69.3718 28.598L35.8367 33.9095C34.8199 34.0705 33.8601 33.376 33.6986 32.356L33.5555 31.4525C32.6815 25.9346 36.4534 20.743 41.9713 19.8691L41.9746 19.8686Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3012 10.4776C52.7402 9.93288 55.9736 12.2821 56.5183 15.7211L57.0666 19.1828L44.6059 21.1564L44.0576 17.6947C43.5129 14.2557 45.8622 11.0222 49.3012 10.4776Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.201 18.3606C51.4757 18.3606 52.5091 17.3273 52.5091 16.0525C52.5091 14.7778 51.4757 13.7444 50.201 13.7444C48.9262 13.7444 47.8928 14.7778 47.8928 16.0525C47.8928 17.3273 48.9262 18.3606 50.201 18.3606Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_6463_2782",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 33,
			y: 16,
			width: 38,
			height: 18,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M41.9545 19.8451L59.1787 17.1171C64.6966 16.2431 69.8882 20.015 70.7621 25.533L70.9052 26.4364C71.0663 27.4532 70.3718 28.413 69.3518 28.5746L35.8167 33.886C34.7999 34.0471 33.8401 33.3526 33.6785 32.3326L33.5354 31.4291C32.6615 25.9112 36.4334 20.7196 41.9513 19.8457L41.9545 19.8451Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_6463_2782)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M73.0589 25.1913L31.2468 31.8137L31.8695 35.7449L73.6815 29.1226L73.0589 25.1913Z",
				fill: "#6BA6FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.3902 53.5448C49.0168 53.6036 48.7712 53.9702 48.8611 54.3367C49.8156 58.2064 53.5884 60.7724 57.5999 60.1499C61.6149 59.5309 64.4333 55.9448 64.1774 51.9679C64.1531 51.591 63.8073 51.3178 63.4339 51.3731L49.3902 53.5414V53.5448Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.635 57.1206C61.0374 55.976 59.0143 55.4296 56.9187 55.7547C54.8265 56.0797 53.0594 57.2105 51.8801 58.784C53.4778 59.9287 55.5008 60.4751 57.5965 60.15C59.6921 59.8249 61.4558 58.6941 62.635 57.1206Z",
			fill: "#DCEBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.0238 44.6711C48.8371 43.4573 47.6993 42.6273 46.489 42.8141C45.2752 43.0008 44.4452 44.1386 44.6319 45.3489C44.8187 46.5627 45.9564 47.3927 47.1668 47.206C48.3806 47.0192 49.2106 45.8815 49.0238 44.6711Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M65.4882 42.0603C65.3014 40.8465 64.1637 40.0165 62.9533 40.2032C61.7395 40.39 60.9096 41.5277 61.0963 42.7381C61.283 43.9519 62.4208 44.7818 63.6311 44.5951C64.845 44.4084 65.6749 43.2706 65.4882 42.0603Z",
			fill: "#9EC5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M93.4803 84.5902C104.639 84.5902 113.685 75.5443 113.685 64.3856C113.685 53.2268 104.639 44.1809 93.4803 44.1809C82.3216 44.1809 73.2756 53.2268 73.2756 64.3856C73.2756 75.5443 82.3216 84.5902 93.4803 84.5902Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.7668 78.8098C87.1314 77.5849 88.4199 76.8867 89.6448 77.2512C90.558 77.523 91.5132 77.7006 92.4993 77.7717C93.7738 77.8638 94.7328 78.9718 94.6409 80.2463C94.549 81.521 93.4409 82.4797 92.1663 82.3879C90.8424 82.2925 89.5562 82.0543 88.3245 81.6877C87.0996 81.3232 86.4025 80.0346 86.7668 78.8098ZM93.4807 46.3362C103.449 46.3363 111.53 54.4176 111.53 64.386C111.529 71.6333 107.258 77.8779 101.106 80.7493C99.9476 81.2897 98.57 80.7892 98.0295 79.6311C97.4893 78.473 97.9907 77.0963 99.1487 76.5559C103.733 74.4166 106.901 69.7688 106.902 64.386C106.902 56.9736 100.893 50.9643 93.4807 50.9641C91.418 50.9641 89.47 51.4284 87.7297 52.2551C87.5498 52.3406 87.372 52.4296 87.1965 52.5227C86.0678 53.1221 84.667 52.6925 84.0676 51.5637C83.4685 50.4351 83.8971 49.0342 85.0256 48.4348C85.2617 48.3095 85.5012 48.1895 85.7434 48.0745C88.091 46.9592 90.7167 46.3362 93.4807 46.3362ZM79.0862 71.1594C80.1504 70.4519 81.5866 70.7417 82.2942 71.8059C82.8248 72.6039 83.4393 73.3419 84.1243 74.0081C85.0404 74.899 85.061 76.3643 84.1702 77.2805C83.2792 78.1967 81.8139 78.2173 80.8977 77.3264C79.9784 76.4324 79.1538 75.4409 78.4407 74.3684C77.7331 73.3042 78.0219 71.867 79.0862 71.1594ZM77.7454 62.0715C79.0232 62.0718 80.0588 63.1081 80.0588 64.386C80.0589 64.9961 80.0997 65.5955 80.178 66.1819C80.3471 67.4486 79.4574 68.6133 78.1907 68.7825C76.9239 68.9516 75.7592 68.061 75.5901 66.7942C75.4848 66.0054 75.4309 65.2014 75.4309 64.386C75.4309 63.108 76.4674 62.0715 77.7454 62.0715ZM78.8225 53.8508C79.5691 52.8136 81.0158 52.5778 82.053 53.3245C83.0901 54.0711 83.3259 55.5177 82.5793 56.5549C82.1707 57.1226 81.8055 57.7233 81.4885 58.3518C80.913 59.4927 79.5212 59.9507 78.3801 59.3752C77.239 58.7997 76.7802 57.4079 77.3557 56.2668C77.7824 55.4209 78.2736 54.6134 78.8225 53.8508Z",
			fill: "#6BA6FF"
		})
	]
});
export default SvgEmptyStateWidgetTaskInProgress;
